<div class="construction-container">
  <div class="logo-section">
    <img src="assets/images/excuela-logo-white.svg" [alt]="'constructionPage.logoAlt' | translate" class="logo">
  </div>
  
  <div class="message-section">
    <div class="construction-icon">
      <i class="fas fa-tools"></i>
    </div>
    <h1 class="title">{{ 'constructionPage.title' | translate }}</h1>
    <p class="message">{{ 'constructionPage.message' | translate }}</p>
    <div class="progress-bar">
      <div class="progress-fill"></div>
    </div>
  </div>
</div>
